export default __webpack_public_path__ + "static/media/Raider's Jerkin of Woven Clouds.ae811327.jpg";